<script>
    export let src;
    export let alt = "";
    export let width = "auto";
    export let height = "auto";
</script>

<img {src} {alt} width="{width}" height="{height}" />

<style>
    img {
        overflow: hidden;
        max-width: fit-content;
        max-height: fit-content;
    }
</style>
